import React from "react";

const NotificationCallCreated = () => {
  return (
    <div className="flex flex-col gap-4 p-2">
      <div>Agente actualizado correctamente</div>
    </div>
  );
};
export default NotificationCallCreated;
